window.MathJax = {
  tex: {
    inlineMath: [
      // ['$', '$'],
      ['\\(', '\\)'],
      // ['<math>', '</math>']
    ]
  },
  svg: {
    fontCache: 'global'
  }
}
